import AddOrder from "../pages/AddOrder";
import Protected from "../components/Protected";
import ShipData from "../pages/ShipData";
import ShippingList from "../pages/ShippingList";
import OrderList from "../pages/OrderList";

const routes = [
  {
    path: "/addOrder",
    element: (
      <Protected role="Add Order">
        <AddOrder />
      </Protected>
    ),
  },
  {
    path: "/shipData",
    element: (
      <Protected role="Shipping Info">
        <ShipData />
      </Protected>
    ),
  },
  {
    path: "/shipList",
    element: (
      <Protected role="Shipping List">
        <ShippingList />
      </Protected>
    ),
  },

  {
    path: "/orderList",
    element: (
      <Protected role="Order List">
        <OrderList />
      </Protected>
    ),
  },
];

export default routes;
